import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6ab19fcc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "backend",
  class: "mb-16"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "Proyectos Back-end", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-mono-label text-xs uppercase tracking-[0.14em] text-subtle -mt-4 mb-8" }, " Proyectos personales ", -1))
const _hoisted_4 = { class: "grid grid-cols-1 md:grid-cols-2 gap-10" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "font-serif-display text-xl text-ink mb-1" }
const _hoisted_8 = { class: "text-subtle text-sm leading-relaxed mb-2 max-w-[60ch]" }
const _hoisted_9 = { class: "font-mono-label text-[0.7rem] uppercase tracking-[0.08em] text-indigo2 mb-3" }
const _hoisted_10 = ["href"]

import { ref } from 'vue';

interface Proyecto {
  titulo: string;
  descripcion: string;
  imagen: string;
  tecnologias: string[];
  enlace: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProyectosBackend',
  setup(__props) {

const proyectos = ref<Proyecto[]>([
  {
    titulo: 'Backend Forum Alura Challenge',
    descripcion:
      'API REST completa para un foro de cursos: autenticación con JWT, gestión de roles y persistencia en PostgreSQL. Documentada y probable desde Swagger.',
    imagen: require('@/assets/api_foro.png'),
    tecnologias: ['Java', 'Spring Boot', 'PostgreSQL', 'Spring Security', 'JWT', 'CI', 'EC2'],
    enlace: 'http://ec2-18-219-234-115.us-east-2.compute.amazonaws.com:8080/swagger-ui/index.html#',
  },
  {
    titulo: 'Backend Voll Clinic Alura Challenge',
    descripcion:
      'API para gestión de clínica médica: citas, pacientes y médicos, con seguridad JWT y documentación Swagger para probar los endpoints.',
    imagen: require('@/assets/api_clinic.png'),
    tecnologias: ['Java', 'PostgreSQL', 'Spring Boot', 'Spring Security', 'JWT', 'CI', 'EC2'],
    enlace: 'http://ec2-3-135-231-33.us-east-2.compute.amazonaws.com:8080/swagger-ui/index.html#/',
  },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(proyectos.value, (proyecto, index) => {
        return (_openBlock(), _createElementBlock("article", {
          key: index,
          class: "group"
        }, [
          _createElementVNode("a", {
            href: proyecto.enlace,
            target: "_blank",
            rel: "noopener noreferrer",
            class: "block border border-hairline rounded-sm overflow-hidden mb-4"
          }, [
            _createElementVNode("img", {
              src: proyecto.imagen,
              alt: proyecto.titulo,
              class: "w-full h-48 object-cover object-top grayscale-[35%] group-hover:grayscale-0 transition-all duration-500"
            }, null, 8, _hoisted_6)
          ], 8, _hoisted_5),
          _createElementVNode("h3", _hoisted_7, _toDisplayString(proyecto.titulo), 1),
          _createElementVNode("p", _hoisted_8, _toDisplayString(proyecto.descripcion), 1),
          _createElementVNode("p", _hoisted_9, _toDisplayString(proyecto.tecnologias.join(' · ')), 1),
          _createElementVNode("a", {
            href: proyecto.enlace,
            target: "_blank",
            rel: "noopener noreferrer",
            class: "text-sm font-semibold text-ink border-b border-ink pb-0.5 hover:text-indigo2 hover:border-indigo2 transition-colors"
          }, " Ver proyecto → ", 8, _hoisted_10)
        ]))
      }), 128))
    ])
  ]))
}
}

})